<template>
    <form action="">
        <div class="info_body mb-2">
            <div class="title mb-2"><a :href="'tel:'+ this.protos_phone_short" class="text-nowrap">{{ protos_phone }}</a></div>
            <a :href="'tel:' + this.protos_phone_short" class="btn btn_lg btn_common">Позвонить в Протос</a>
        </div>

        <div class="info_body">

            <div v-if="ok" class="alert alert-success" role="alert">
                Сообщение отправлено!
            </div>

            <div v-else>
                <div class="form-group">
                    <label for="fb_01_01">Контактный телефон</label>
                    <input
                        type="text"
                        class="form-control"
                        id="fb_01_01"
                        v-model="phone"
                        @change.o="resetErrors"
                        :class="{ 'is-invalid': errors.phone }"
                    />
                    <small id="" class="text-muted">
                        Менеджер перезвонит на этот номер в рабочее время
                    </small>
                </div>

                <div class="form-group mt_sm">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="fb_01_02"
                            v-model="agree"
                            @change.o="resetErrors"
                            :class="{ 'is-invalid': errors.agree }"
                        />
                        <label class="form-check-label" for="fb_01_02">
                            Даю согласие на обработку персональных данных
                        </label>
                    </div>
                </div>
            </div>

            <button
                v-if="ok"
                type="button"
                class="btn btn_lg btn_neutral mt_xxs"
                data-dismiss="modal"
            >
                Закрыть
            </button>

            <button
                v-else
                type="button"
                class="btn btn_lg btn_common mt_xxs"
                @click.prevent="send"
            >
                Заказать обратный звонок
            </button>
        </div>
    </form>
</template>

<script>
export default {
    props: ['url', 'protos_phone', 'protos_phone_short'],

    data: function () {
        return {
            phone: "",
            // phoneShort: this.protosPhoneNumberShort,
            agree: false,
            errors: {},
            ok: false,
        };
    },

    methods: {
        send: function () {
            this.errors = {};
            this.ok = false;

            let error = false;

            if (!this.phone.length) {
                this.errors.phone = 1;
                error = true;
            }

            if (!this.agree) {
                this.errors.agree = 1;
                error = true;
            }

            if (error) return;

            let params = {
                phone: this.phone,
                agree: this.agree,
                url: this.url
            };

            axios.post("/ajax/callback", params).then((request) => {
                if (
                    typeof request.data.success != "undefined" &&
                    request.data.success
                ) {
                    this.ok = true;

                    // Metrika
                    ym(191405, 'reachGoal', 'callback');

                    setTimeout(() => {
                        this.ok = false;
                    }, 5000);
                }
            });
        },

        resetErrors: function (e) {
            this.errors = {};
        },
    },
};
</script>
